import MapsComponent from './components/MapsComponent'
export default MapsComponent
